import React from 'react';
import { Inscription } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import Link from '@/modules/core/components/Link';

import { ActivityLogChangeset, formatValue, NewValueTemplate } from './common';
import DocumentPreviewLink from './DocumentPreviewLink';

const getTemplateUpdatedValue = (item: ActivityLogChangeset): React.ReactNode => {
  if (item.newValueTemplate?.template === NewValueTemplate.DOCUMENT_RENDER) {
    const fileName = item.newValueTemplate.variables.file_name.value;
    const filePath = item.newValueTemplate.variables.file_path.value;
    return <DocumentPreviewLink fileName={fileName} filePath={filePath} />;
  }

  if (item.newValueTemplate?.template === NewValueTemplate.HSA_ACCOUNT_LINK_AP) {
    const employeeId = item.newValueTemplate.variables.employee_id.value;
    const accountId = item.newValueTemplate.variables.account_id.value;
    return (
      <Link to={ROUTES.ENROLLMENT_DETAILS(employeeId, accountId)} isOpenNewTab>
        <Inscription color="navigationAccent" weight="bold" lineHeight="20px">
          {formatValue(item.fieldName, item.newValue)}
        </Inscription>
      </Link>
    );
  }

  return undefined;
};

export { getTemplateUpdatedValue };
